import { FC } from "react";

import { QRCodeSVG } from "qrcode.react";

import { AppPlatform, detectPlatform } from "./utils/platform";

type ElementProps = {
  children: string | JSX.Element | JSX.Element[] | undefined;
};

const ModalContainer: FC<ElementProps> = ({ children }) => {
  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "306px",
        minHeight: "400px",
        //width: "100vw",
        //height: "100vh",
        paddingBottom: 43,
        paddingTop: 43,
        paddingRight: 27,
        paddingLeft: 27,
        borderRadius: "50px 0px",
        //border: "0.5px solid #000",
        background: "#F5F1E5",
        backgroundImage: `url(${"/images/modalBack.png"})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {children}
    </div>
  );
};

const ContainerColumn: FC<ElementProps> = ({ children }) => {
  return (
    <div
      style={{
        color: "#000",
        textAlign: "center",
        fontFamily: "Spezia",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "normal",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      {children}
    </div>
  );
};

interface PropTypes {
  closeModal: () => void;
}

export const DownloadModal: FC<PropTypes> = ({ closeModal }) => {
  const platform = detectPlatform();

  const isMobile =
    platform === AppPlatform.android || platform === AppPlatform.ios;

  return (
    <ModalContainer>
      <div onClick={closeModal}></div>
      <ContainerColumn>
        <img
          src={"/icons/INDYX_Primary_Black.png"}
          alt="logo"
          width={254 * 0.5}
          height={57 * 0.5}
          style={{ marginTop: 50 }}
        />
        <div>Download the Indyx App to RSVP and Place Holds</div>

        <div
          style={{
            display: "flex",
            alignSelf: "center",
          }}
        >
          {!isMobile ? (
            <QRCodeSVG
              size={128}
              bgColor="#F5F1E5"
              //value={window.location.href}
              value={"https://opencloset.myindyx.com/link.html"}
            />
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {platform === AppPlatform.ios ? (
                  <a
                    href="https://apps.apple.com/us/app/indyx-wardrobe-outfit-app/id1599179405"
                    style={{ textDecoration: "none" }}
                  >
                    <img
                      width={159}
                      src="https://images.squarespace-cdn.com/content/v1/6321094c82fde37e691eb3f2/520f1895-8890-48ad-a27d-f53eb21b8376/App%2BStore%2BBadge.png?format=750w"
                      alt="ios"
                    />
                  </a>
                ) : null}
                {platform === AppPlatform.android ? (
                  <a
                    href="https://play.google.com/store/apps/details?gl=US&hl=en_US&id=com.indyx.android"
                    style={{ textDecoration: "none" }}
                  >
                    <img
                      width={159}
                      src="https://images.squarespace-cdn.com/content/v1/6321094c82fde37e691eb3f2/a5ca2abb-b29c-4f8f-a453-4910d057062a/Google%2BPlay%2BBadge.png?format=750w"
                      alt="android"
                    />
                  </a>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </ContainerColumn>
    </ModalContainer>
  );
};
